const safeJsonParse = (value, fallback = null) => {
  if (value == null || value === 'undefined' || value === '') {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
};

export default safeJsonParse;
